import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { getCategoryColor } from '~/hooks/useCategoryColor';
import styles from './CategoryColorIndicator.module.scss';

export type CategoryColorSize = 'small' | 'medium' | 'large' | 'extralarge';

interface Props {
  categoryColor?: string | undefined;
  size: CategoryColorSize;
  className?: string;
}

const CategoryColorIndicator: React.FC<PropsWithChildren<Props>> = ({ categoryColor, size, className, children }) => {
  const colorConfig = getCategoryColor(categoryColor);
  const computedClassName = clsx(
    styles.categoryColorIndicator,
    {
      [styles.small!]: size === 'small',
      [styles.medium!]: size === 'medium',
      [styles.large!]: size === 'large',
      [styles.extralarge!]: size === 'extralarge',
    },
    className,
  );
  return (
    <div
      className={computedClassName}
      style={{
        background: colorConfig.color,
      }}
    >
      {children}
    </div>
  );
};

export default CategoryColorIndicator;
